import { render } from "./ButtonLayout.vue?vue&type=template&id=c626d604&scoped=true&ts=true"
import script from "./ButtonLayout.vue?vue&type=script&lang=ts"
export * from "./ButtonLayout.vue?vue&type=script&lang=ts"

import "./ButtonLayout.vue?vue&type=style&index=0&id=c626d604&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c626d604"]])

export default __exports__